import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "message"]

  async validate() {
    const code = this.inputTarget.value.trim()
    if (!code) {
      this.messageTarget.textContent = ""
      this.messageTarget.className = "mt-1 text-sm text-slate-500"
      return
    }

    try {
      const response = await fetch(`/referrals/validate?code=${encodeURIComponent(code)}`)
      const data = await response.json()

      this.messageTarget.textContent = data.message
      this.messageTarget.className = data.valid
        ? "mt-1 text-sm text-green-600"
        : "mt-1 text-sm text-red-600"
    } catch {
      this.messageTarget.textContent = ""
    }
  }
}
